const CheckUrlMatch = (routes, location) => {
	let isMatch = false;
    routes.forEach(element => {
        if(element.path === location){
            isMatch = true;
        }        
    });
	return isMatch;

}

export {CheckUrlMatch};